var req = require("!!/Users/admin/hogan/portfolio/node_modules/pug-loader/index.js!/Users/admin/hogan/portfolio/src/app/resume/cann-north/cann-north-resume.component.pug");
module.exports = (req['default'] || req).apply(req, [])